export default "__VITE_ASSET__09779fb4__"